import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {isReddata} from '../helperFunction/_helper'

type LogoProps = {
  classname: string
  path?: string
}

const pathurl = isReddata() ? '/media/logos/reddata-logo.png' : '/media/logos/iatl-logo.png'

const Logo = ({classname, path = pathurl}: LogoProps) => {
  return <img alt='Logo' src={toAbsoluteUrl(path)} className={classname} />
}

export default Logo
